import {
  TREQUEST_ORDER_LIST,
  TRESPONSE_ORDER_LIST,
  TRESPONSE_ORDER_UPLOAD_DETAILS,
  TREQUEST_ASSIGN_TNA_TO_ORDERS,
  TREQUEST_ORDER_SINGLE_FACTORY_ALLOCATION,
  TREQUEST_ORDER_VIEW_FACTORY_ALLOCATION,
  TREQUEST_ORDER_ALLOCATION_CREATE_SPLIT_VIEW,
  TRESPONSE_ORDER_MULTIPLE_FACTORY_ALLOCATIONS,
  TREQUEST_ALLOCATE_ORDER_MULTIPLE_FACTORIES,
  TREQUEST_DELETE_ORDERS,
  TFilterSelected,
  TOrderListViewType,
} from '@monorepo/types';
import { TFilterGroupModel, TUserPaginationOption } from '@monorepo/ui';
import { Action } from '@ngrx/store';
import { TOrderListActionType } from './order-list.models';

export class GetOrderList implements Action {
  readonly type = TOrderListActionType.GetOrderList;
  constructor(
    public payload: TREQUEST_ORDER_LIST,
    public path: 'ORDER_LISTING_SCREEN' | 'ASSIGN TNA TO ORDERS SCREEN' = 'ORDER_LISTING_SCREEN',
  ) {}
}

export class GetOrderListSuccess implements Action {
  readonly type = TOrderListActionType.GetOrderListSuccess;
  constructor(public OrderListRes: TRESPONSE_ORDER_LIST) {}
}

export class GetOrderListFailure implements Action {
  readonly type = TOrderListActionType.GetOrderListFailure;
  constructor() {}
}

export class SetUserPaginationOption implements Action {
  readonly type = TOrderListActionType.SetUserPaginationOption;
  constructor(public userPaginationOption: TUserPaginationOption) {}
}

export class GetOrderUploadDetails implements Action {
  readonly type = TOrderListActionType.GetOrderUploadDetails;
  constructor() {}
}

export class GetOrderUploadDetailsSuccess implements Action {
  readonly type = TOrderListActionType.GetOrderUploadDetailsSuccess;
  constructor(public orderUploadDetailsRes: TRESPONSE_ORDER_UPLOAD_DETAILS) {}
}

export class GetOrderUploadDetailsFailure implements Action {
  readonly type = TOrderListActionType.GetOrderUploadDetailsFailure;
  constructor() {}
}

export class AssignTnaToOrders implements Action {
  readonly type = TOrderListActionType.AssignTnaToOrders;
  constructor(public payload: TREQUEST_ASSIGN_TNA_TO_ORDERS, public getOrdersPayload: TREQUEST_ORDER_LIST) {}
}

export class AssignTnaToOrdersSuccess implements Action {
  readonly type = TOrderListActionType.AssignTnaToOrdersSuccess;
}

export class AssignTnaToOrdersFailure implements Action {
  readonly type = TOrderListActionType.AssignTnaToOrdersFailure;
}

export class AssignSingleFactoryToOrder implements Action {
  readonly type = TOrderListActionType.AssignSingleFactoryToOrder;
  constructor(public payload: TREQUEST_ORDER_SINGLE_FACTORY_ALLOCATION) {}
}

export class AssignSingleFactoryToOrderSuccess implements Action {
  readonly type = TOrderListActionType.AssignSingleFactoryToOrderSuccess;
}

export class AssignSingleFactoryToOrderFailure implements Action {
  readonly type = TOrderListActionType.AssignSingleFactoryToOrderFailure;
}

export class ViewFactoryAllocation implements Action {
  readonly type = TOrderListActionType.ViewFactoryAllocation;
  constructor(public payload: TREQUEST_ORDER_VIEW_FACTORY_ALLOCATION) {}
}

export class ViewFactoryAllocationSuccess implements Action {
  readonly type = TOrderListActionType.ViewFactoryAllocationSuccess;
}

export class ViewFactoryAllocationFailure implements Action {
  readonly type = TOrderListActionType.ViewFactoryAllocationFailure;
}

export class GetOrderToFactoriesSplit implements Action {
  readonly type = TOrderListActionType.GetOrderToFactoriesSplit;
  constructor(public payload: TREQUEST_ORDER_ALLOCATION_CREATE_SPLIT_VIEW) {}
}

export class GetOrderToFactoriesSplitSuccess implements Action {
  readonly type = TOrderListActionType.GetOrderToFactoriesSplitSuccess;
  constructor(public orderToFactoriesRes: TRESPONSE_ORDER_MULTIPLE_FACTORY_ALLOCATIONS) {}
}

export class GetOrderToFactoriesSplitFailure implements Action {
  readonly type = TOrderListActionType.GetOrderToFactoriesSplitFailure;
}

export class AllocateOrderToMultipleFactories implements Action {
  readonly type = TOrderListActionType.AllocateOrderToMultipleFactories;
  constructor(public payload: TREQUEST_ALLOCATE_ORDER_MULTIPLE_FACTORIES) {}
}

export class AllocateOrderToMultipleFactoriesSuccess implements Action {
  readonly type = TOrderListActionType.AllocateOrderToMultipleFactoriesSuccess;
}

export class AllocateOrderToMultipleFactoriesFailure implements Action {
  readonly type = TOrderListActionType.AllocateOrderToMultipleFactoriesFailure;
}
export class DeleteOrders implements Action {
  readonly type = TOrderListActionType.DeleteOrders;
  constructor(public deleteOrdersPayload: TREQUEST_DELETE_ORDERS, public fetchOrderspayload: TREQUEST_ORDER_LIST) {}
}

export class DeleteOrdersSuccess implements Action {
  readonly type = TOrderListActionType.DeleteOrdersSuccess;
  constructor() {}
}

export class DeleteOrdersFailure implements Action {
  readonly type = TOrderListActionType.DeleteOrdersFailure;
  constructor() {}
}

export class GetViewOrderFactoryAllocation implements Action {
  readonly type = TOrderListActionType.ViewOrderFactoryAllocation;
  constructor(public payload: TREQUEST_ORDER_VIEW_FACTORY_ALLOCATION) {}
}

export class GetViewOrderFactoryAllocationSuccess implements Action {
  readonly type = TOrderListActionType.ViewOrderFactoryAllocationSuccess;
  constructor(public orderFactoryAllocationRes: TRESPONSE_ORDER_MULTIPLE_FACTORY_ALLOCATIONS) {}
}

export class GetViewOrderFactoryAllocationFailure implements Action {
  readonly type = TOrderListActionType.ViewOrderFactoryAllocationFailure;
}

export class SetOrderListSelectedFilters implements Action {
  readonly type = TOrderListActionType.SetOrderListSelectedFilters;
  constructor(public filterModel: TFilterGroupModel<TFilterSelected>) {}
}

export class SetOrderListBucketInfo implements Action {
  readonly type = TOrderListActionType.SetOrderListBucketInfo;
  constructor(public viewType: TOrderListViewType) {}
}

export type TOrderListActions =
  | GetOrderList
  | GetOrderListSuccess
  | GetOrderListFailure
  | SetUserPaginationOption
  | GetOrderUploadDetails
  | GetOrderUploadDetailsFailure
  | GetOrderUploadDetailsSuccess
  | AssignTnaToOrders
  | AssignTnaToOrdersSuccess
  | AssignTnaToOrdersFailure
  | AssignSingleFactoryToOrder
  | AssignSingleFactoryToOrderSuccess
  | AssignSingleFactoryToOrderFailure
  | ViewFactoryAllocation
  | ViewFactoryAllocationSuccess
  | ViewFactoryAllocationFailure
  | GetOrderToFactoriesSplit
  | GetOrderToFactoriesSplitSuccess
  | GetOrderToFactoriesSplitFailure
  | AllocateOrderToMultipleFactories
  | AllocateOrderToMultipleFactoriesSuccess
  | AllocateOrderToMultipleFactoriesFailure
  | DeleteOrders
  | DeleteOrdersSuccess
  | DeleteOrdersFailure
  | GetViewOrderFactoryAllocation
  | GetViewOrderFactoryAllocationSuccess
  | GetViewOrderFactoryAllocationFailure
  | SetOrderListSelectedFilters
  | SetOrderListBucketInfo;
